module.exports = __webpack_public_path__ + "static/error-intech-48b7a26255d0bc855517a7cbe2155fad.png";